import { authedFetch } from '@features/auth/api/authRefresh'
import type { NotificationListResponseWire, NotificationMarkReadResponseWire } from '../types'

/**
 * 通知 REST クライアント (T-H1)。
 *
 *   GET    /api/notifications        — 最新 50 件 + unreadCount
 *   PATCH  /api/notifications/read   — `ids` 指定で個別既読 / 省略で全件既読化
 *   DELETE /api/notifications        — 全件削除
 *   DELETE /api/notifications/:id    — 1 件削除
 */

const BASE = '/notifications'

export const listNotifications = (): Promise<NotificationListResponseWire> =>
  authedFetch<NotificationListResponseWire>(BASE)

export const markNotificationsRead = (
  ids?: readonly string[] | null,
): Promise<NotificationMarkReadResponseWire> =>
  authedFetch<NotificationMarkReadResponseWire>(`${BASE}/read`, {
    method: 'PATCH',
    body: ids && ids.length > 0 ? { ids: [...ids] } : {},
  })

export const deleteNotification = (id: string): Promise<NotificationMarkReadResponseWire> =>
  authedFetch<NotificationMarkReadResponseWire>(`${BASE}/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  })

export const deleteAllNotifications = (): Promise<NotificationMarkReadResponseWire> =>
  authedFetch<NotificationMarkReadResponseWire>(BASE, { method: 'DELETE' })
